export interface FileWithPath extends File {
    readonly path?: string
}

export enum Stage {
    Init = 'init',
    Processing = 'processing',
    Completed = 'completed',
}

export type LumiContextValue = {
    acceptedFiles: readonly FileWithPath[]
    onChangeAcceptedFiles: (acceptedFiles: readonly FileWithPath[]) => void
    stage: Stage
    onChangeStage: (stage: Stage) => void
}
